export default __webpack_public_path__ + "static/media/label-transport.33a42004.svg";